export type UiDocumentItem = {
  id: string
  filename: string
  scope?: string
  status?: string
  error_message?: string | null
  size_bytes?: number
  created_at?: string
}

export const PROCESSING_STATUSES = new Set([
  'initiated',
  'uploaded',
  'pending',
  'parsing',
  'indexing',
  'processing',
])

export function normalizeSelectedDocIds(raw: unknown): string[] {
  if (!Array.isArray(raw)) return []
  const uniqueIds: string[] = []
  const seen = new Set<string>()
  for (const item of raw) {
    const id = String(item || '').trim()
    if (!id || seen.has(id)) continue
    seen.add(id)
    uniqueIds.push(id)
  }
  return uniqueIds
}

export function isHomeAttachableDocument(doc: UiDocumentItem): boolean {
  const status = String(doc.status || '').toLowerCase()
  if (status !== 'ready') return false
  const scope = String(doc.scope || '').toLowerCase()
  return scope !== 'chat'
}

export function documentStatusLabel(status?: string): string {
  const normalized = String(status || '').toLowerCase()
  if (normalized === 'ready') return 'Готов'
  if (normalized === 'error') return 'Ошибка'
  if (normalized === 'pending') return 'В очереди'
  if (normalized === 'initiated') return 'Запущено'
  if (normalized === 'uploaded') return 'Загружен'
  if (normalized === 'parsing') return 'Парсится'
  if (normalized === 'indexing') return 'Индексируется'
  if (!normalized) return 'Неизвестно'
  return 'Обработка'
}

export function humanizeDocError(raw?: string | null): string | null {
  const message = String(raw || '').trim()
  if (!message) return null
  const lowered = message.toLowerCase()
  if (lowered.includes('429 too many requests') && lowered.includes('embeddings')) {
    return 'Сервис индексации временно перегружен. Повторите позже.'
  }
  if (lowered.includes('500 internal server error') && lowered.includes('embeddings')) {
    return 'Сервис индексации временно недоступен. Повторите позже.'
  }
  if (lowered.includes('timeout') || lowered.includes('timed out')) {
    return 'Превышено время обработки документа. Повторите позже.'
  }
  if (lowered.includes('not a valid point id')) {
    return 'Ошибка индексации документа. Перезагрузите документ.'
  }
  return message.length > 180 ? `${message.slice(0, 177)}...` : message
}

export function formatDocDateTime(value?: string): string | null {
  const source = String(value || '').trim()
  if (!source) return null
  const date = new Date(source)
  if (Number.isNaN(date.getTime())) return null
  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
